import React from 'react';
import { Field } from 'formik';
import PropTypes from 'prop-types';
import '../../../assets/css/componentStyles/FormPill.css';
import classNames from 'classnames';

function FormPill({
  groupName,
  feature,
  isFeatureSelected,
  deleteCallback,
  handleClick,
  className,
}) {
  return (
    <label
      className={classNames(
        'form-pill-variant',
        'mr-3',
        'noselect',
        { 'form-pill-variant--selected': isFeatureSelected },
        className,
      )}
    >
      <Field
        type="checkbox"
        name={groupName}
        value={feature}
        checked={isFeatureSelected}
        onClick={() => {
          deleteCallback(feature);
          handleClick();
        }}
      />
      {feature}
    </label>
  );
}

export default FormPill;

FormPill.defaultProps = {
  deleteCallback: () => {},
  handleClick: () => {},
  className: '',
};

FormPill.propTypes = {
  groupName: PropTypes.string.isRequired,
  feature: PropTypes.string.isRequired,
  isFeatureSelected: PropTypes.bool.isRequired,
  deleteCallback: PropTypes.func,
  handleClick: PropTypes.func,
  className: PropTypes.string,
};
